// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuButton_button__2nOpO","menuButtonLine":"MenuButton_menuButtonLine__2srwc","menuOpen":"MenuButton_menuOpen__30a1r"};